import { Pipe, PipeTransform } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { CommonState } from "../../store/reducer";
import { CurrentState } from "../../store/current-state";
import {lastValueFrom} from "rxjs";

@Pipe({
  name: 'authImage',
})
export class AuthImagePipe implements PipeTransform {
  constructor(
    private http: HttpClient,
    protected currentState: CurrentState<CommonState>
  ) {}

  async transform(src: string): Promise<any> {
    console.log('transform called');
    const token = this.currentState.snapshot.user.token;
    const headers = new HttpHeaders({ 'Authorization': `Bearer ${token}` });
    const imageBlob = await lastValueFrom(
      this.http.get(src, { headers, responseType: 'blob' })
    );
    const reader = new FileReader();
    return new Promise((resolve, reject) => {
      reader.onloadend = () => resolve(reader.result as string);
      reader.readAsDataURL(imageBlob);
    });
  }
}
